/*
Author : Raphaël Dardeau


Setup :

var connection;
$(function() {
	// set connection with datas stored in yourcookie
	connection = $(document).checkConnection({
		cookieName:"yourcookie",
		facebookAppId:"yourfbid",
	}).data("plugin_checkConnection");

	// if you want to update connection with new datas
	var datas = {nickname:"Raphael", ...};
	connection.setDatas(datas);
	connection.setDisplay();

	// if you want to logout
	var datas = null;
	connection.setDatas(datas);
	connection.setDisplay();
*/

;(function ( $, window, document, undefined ) {
    var pluginName = "checkConnection",
        defaults = {
        	cookieName: 'connection',
        	cookieExpires: 0,
			facebookAppId: '106425419465177',
			autoInitExt: true
        };

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

        init: function() {
			this.getCookie();
			this.setDisplay();
			this.setEvents();

			if (this.settings.autoInitExt)
				this.initExt();
		},

        initExt: function() {
			if (this.settings.facebookAppId && !this.fbIsLoaded) {
				cmp.getCmpConsent('purpose', cmp.getKeyForPurpose('essentials')).then(function (consent) {
					if (consent) {
						$.getScript("//connect.facebook.net/en_US/sdk.js", $.proxy(function(data, textStatus, jqxhr) {
							if (jqxhr.status == 200) {
								FB.init({
									appId: this.settings.facebookAppId,
									cookie: true,
									xfbml: true,
									version: 'v2.10'
								});
								$(document).on("click", "#fbloginBtn", $.proxy(function(e) {
									this.fbLogin();
									e.preventDefault();
								}, this));
								this.fbIsLoaded = true;
							} else {
								$("#fbloginBtn").hide();
							}
						}, this));
					}
				})
			}
		},

		getCookie: function() {
			var cookie = $.cookie(this.settings.cookieName);
			if (cookie)
				this.datas = JSON.parse(cookie);
			else
				this.datas = null;
		},

        setCookie: function() {
            var options = {path: '/'};
            if (this.settings.cookieExpires > 0)
            	options["expires"] = this.settings.cookieExpires;
            $.cookie(this.settings.cookieName, JSON.stringify(this.datas), options);
        },

		isLoggedIn: function(datas) {
			return (this.datas) ? true : false;
		},

		setDatas: function(datas) {
			this.datas = datas;
			if (this.settings.cookieExpires !== false)
				this.setCookie();
		},

		setEvents: function() {
			$(document).on("click", ".js-user-login", $.proxy(function (e) {
				this.login();
				e.preventDefault();
			}, this));
			$(document).on("click", ".js-user-logout", $.proxy(function (e) {
				this.logout()
				e.preventDefault();
			}, this));
		},

		login: function(callback) {
			if (!this.isLoggedIn()) {
				$(".js-user-button").trigger("click");
				if (callback)
					$(document).off("connection-login").one("connection-login", callback);
			} else if (callback) {
				callback();
			}
		},

		logout: function(callback) {
			if (this.isLoggedIn()) {
				$(".js-form-logout").trigger("submit");
				if (callback)
					$(document).off("connection-logout").one("connection-logout", callback);
			} else if (callback) {
				callback();
			}
		},

		fbLogin: function() {
			var _this = this;
			if ($("#fbloginBtn").hasClass("is-loading"))
				return false;

			$("#fbloginBtn").addClass("is-loading");
			FB.login(function() {
				FB.getLoginStatus(function(response) {
					if (response.status === 'connected') {
						var access_token = response.authResponse.accessToken;
						FB.api( '/me',
                                'GET',
                                {"fields": "email,name,first_name,last_name,gender,locale,link"},
                                function(response) {
                                var extDatas = {};
                                extDatas["provider"] = "facebook";
                                extDatas["token"] = access_token;
                                extDatas["id"] = response.id;
                                extDatas["email"] = response.email;
                                extDatas["full_name"] = response.name;
                                extDatas["first_name"] = response.first_name;
                                extDatas["last_name"] = response.last_name;
                                extDatas["gender"] = response.gender;
                                extDatas["lang"] = response.locale ? response.locale.substring(0, 2) : 'fr';
                                extDatas["image"] = 'http://graph.facebook.com/'+ response.id +'/picture';
                                extDatas["link"] = response.link;
                                $(".js-form-extlogin").find("[name='provider']").val("facebook");
                                $(".js-form-extlogin").find("[name='datas']").val(JSON.stringify(extDatas));
                                $(".js-form-extlogin").trigger("submit");
                            });
					} else {
						$("#fbloginBtn").removeClass("is-loading");
					}
				});
			},
			{
				scope: 'email',
				auth_type: 'rerequest'
			});
		},

        setDisplay: function() {
			if (!this.datas) {
				$("body").removeClass("is-loggedIn");
                $("body").removeClass("is-subscriber");
				$(".js-user-button").removeClass("is-premium");
				$(".js-user-loggedIn").hide();
				$(".js-user-notLoggedIn").show();
				$(".js-user-isAbo").hide();
				$(".js-user-notAbo").show();
				$(".js-user-name").text("");
				$(".js-user-image").attr("src", $(".js-user-image").data("src"));
				$(document).trigger("connection-logout");
			} else {
				$("body").addClass("is-loggedIn");
				$(".js-user-loggedIn").show();
				$(".js-user-notLoggedIn").hide();
				if (this.datas.magAbonne) {
                    $("body").addClass("is-subscriber");
					$(".js-user-isAbo").show();
					$(".js-user-notAbo").hide();
					$(".js-user-button").addClass("is-premium");
					if ($(".page-home").length)
						$("[data-ads-formatid]:not(.js-ads-square, .js-ads-better)").remove();
					else
						$("[data-ads-formatid]:not(.js-ads-better)").remove();
					if (lazyads)
						lazyads.setElements();
				} else {
					$(".js-user-isAbo").hide();
					$(".js-user-notAbo").show();
				}
				$(".js-user-name").text(this.datas.nickname);
				if (this.datas.image)
					$(".js-user-image").attr("src", this.datas.image);
				else
					$(".js-user-image").attr("src", $(".js-user-image").data("src"));
				$(document).trigger("connection-login");
			}
		}

    });

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );
